import React, { Component } from 'react'
import { ICriteria } from '../../../layout-configuration-panel/ILayoutConfigurationPanel.Interface';
import { CQAppConstant } from '../../../../../app-constants';
import { TemplateSFObjectStore } from '../../../../../store/models/template-object.model';
import GridTemplateConfigurationController from '../../grid-template-config.controller';
import { Utility } from '../../../../../common/utility';
import { GridActionsReducer } from '../action-controller/grid-actions.reducer';
import { CQMasterDataStore } from '../../../../../store/cq-master-data.store';
import GridModal, { IState } from '../../grid-modal.component';

const INITIAL_CRITERIA = {
    field: '',
    operator: '',
    compareTo: '',
    isDynamic: false,
    referenceField: '',
    referenceTo: '',
    selectedFieldType: '',
    relationshipName: ''
}

export class GridHeaderStdVisibilityRuletModal extends Component<any, IState>{

    private gridTemplateController: GridTemplateConfigurationController;
    private gridActionsReducer: GridActionsReducer;
    private cqUtilityClass: Utility;
    constructor(props: any) {
        super(props);
        this.gridTemplateController = new GridTemplateConfigurationController();
        this.gridActionsReducer = new GridActionsReducer();
        this.cqUtilityClass = new Utility();
        this.state = {
            addedCriterias: [{
                field: '',
                operator: '',
                compareTo: '',
                isDynamic: false,
                referenceField: '',
                referenceTo: '',
                selectedFieldType: '',
                relationshipName: ''
            }],
            complexLogicQuery: '',
            shouldSkip: false,
            isVisible: '',
            complexLogicVisibility: false,
            isFormValid: true,
            ruleObject: {},
            ruleJSON: ''
        };
    }

    componentDidMount() {
        if (this.props.ruleObject && Object.keys(this.props.ruleObject).length > 0) {
            this.setState({
                addedCriterias: this.props.ruleObject.hasOwnProperty('addedCriterias') ? this.props.ruleObject.addedCriterias : [{
                    field: '',
                    operator: '',
                    compareTo: '',
                    isDynamic: false
                }],
                complexLogicQuery: this.props.ruleObject.hasOwnProperty('complexLogicQuery') ? this.props.ruleObject.complexLogicQuery : '',
                complexLogicVisibility: this.props.ruleObject.hasOwnProperty('complexLogicVisibility') ? this.props.ruleObject.complexLogicVisibility : false,
                // additionalFields: this.props.ruleObject.hasOwnProperty('complexLogicVisibility') ? this.props.ruleObject.additionalFields:,
                isVisible: this.props.ruleObject.hasOwnProperty('isVisible') ? this.props.ruleObject.isVisible : 'true'
            });
        }
    }

    /**
     * Fuction reuturns required action to be performed 
     * @param actionType reuired aaction name
     * @param value state property to be updated
     */
    onModalActionPerformed = (actionType: string, value?: IState) => {
        switch(actionType) {
            case 'closeModal': 
                this.props.toggleModalVisibility();
                break;
            
            case 'previewRule':
                this.previewRule();
                break;
            
            case 'saveRule':
                this.SaveRule();
                break;

            case 'updateState':
                this.updateState(value!);
                break;

            default:
                // do nothing
        }
    }

    /**
     * Updates state and ruleobject
     * @param state update states property
     */
    updateState = (state: IState) => {
        let stateCopy = this.cqUtilityClass.createObjectDeepCopy(this.state);
        stateCopy = {...stateCopy, ...state};
        this.setState(stateCopy, () => {
            this.updateRuleObject(CQAppConstant.ADDED_CRITERIAS, this.state);
        });
    }

    /**
     *
     * @returns fields array
     */
    getObjectFields = () => {
        let parentObjectFields = TemplateSFObjectStore.mainReferenceObjectFields.fields.map((field: any) => {
            const tempField = {
                ...field,
                fieldFullName: field.name as string,
                fieldLabel: field.label as string
            };

            return tempField;
        });
        parentObjectFields = parentObjectFields.sort((a: any, b: any) => { 
            return a.fieldLabel > b.fieldLabel ? 
                1 : 
                (a.fieldLabel === b.fieldLabel ? 0 : -1); 
        });

        return parentObjectFields;
    }

    render() {     
        return (
            <GridModal 
                onActionPerformed= {this.onModalActionPerformed}
                modalInfo= {{
                    optionInfo: {
                        options: this.getObjectFields()
                    },
                    gridType: 'headerAction',
                    isFormValid: this.state.isFormValid,
                    label: this.props.ruleObject && Object.keys(this.props.ruleObject).length > 0 ? `Add Rule (Visibility)` : `Edit Rule (Visibility)`
                }}
                modalState= {{
                    initialCriteria: INITIAL_CRITERIA,
                    state: this.state
                }}
                templateName= {this.props.selectedTemplateName}
            />
        );
    }
    
    /**
     * Updates rule to be set 
     * @param ruleObjectProperty 
     * @param ruleObjectValue property required for rule to be set
     */
    private updateRuleObject = (ruleObjectProperty: string, ruleObjectValue: any) => {
        // const ruleObject: any = { ...this.state.ruleObject };
        // ruleObject[ruleObjectProperty] = ruleObjectValue;
        const isFormValid = this.validateAddRuleForm();
        this.setState({
            ...this.state,
            isFormValid,
            ruleObject: ruleObjectValue
        });
    }

    /**
     * 
     * @returns Validates rule for added property
     */
    private validateAddRuleForm = () => {
        if (this.state.isVisible === 'true') {
            let isComplexLogicValid = false;
            const isCriteriaValid = this.state.addedCriterias.every((criteria: ICriteria) => (criteria.field !== ''
                && criteria.operator !== ''
                && ((criteria.operator === CQAppConstant.EXISTS || criteria.operator === CQAppConstant.ISEMPTY) ? true : (criteria.compareTo !== ''))));
            if (this.state.addedCriterias.length === 1 && this.state.complexLogicQuery === '') {
                isComplexLogicValid = true;
            } else if (this.state.addedCriterias.length > 1 && this.state.complexLogicQuery === '') {
                isComplexLogicValid = false;
            } else if (this.state.addedCriterias.length > 1 && this.state.complexLogicQuery !== '') {
                isComplexLogicValid = true;
            }
            if (!isCriteriaValid || !isComplexLogicValid) {
                return true;
            }
            return false;
        } else {
            return false;
        }

    }

    /**
     * Preview rule for added ruleObject 
     */
    private previewRule = () => {
        const ruleObject: any = this.gridTemplateController.getVisibilityRuleController(this.cqUtilityClass.createObjectDeepCopy(this.state.ruleObject));
        this.setState({ ruleJSON: JSON.stringify(ruleObject, undefined, 2) });
    }
    
    /**
     * Saves rule for ruleobject added
     */
    private SaveRule = async () => {
        this.gridActionsReducer.storeViewModel(this.props.actionType, this.state.ruleObject, this.props.selectedTemplateName, 'headerActions');
        const ruleObject: any = this.gridTemplateController.getRuleController(this.cqUtilityClass.createObjectDeepCopy(this.state.ruleObject));
        let fields: any[] = [];
        let addtionalFields: any[] = [];
        let additionalFieldsArray: any[] = [];
        const viewConfigGridComponent = { ...CQMasterDataStore.GridObject.gridComponentConfigView };
        const columnFields = { ...viewConfigGridComponent.displayFields };
        Object.keys(columnFields).forEach((columnField: any) => {
            if (typeof columnFields[columnField] === 'object') {
                Object.keys(columnFields[columnField]).forEach((currentFieldKey: string) => {
                    addtionalFields.push(currentFieldKey);
                    addtionalFields.push(columnFields[columnField][currentFieldKey]);
                });
            } else {
                addtionalFields.push(columnFields[columnField]);
            }
        });
        this.state.addedCriterias.length && this.state.addedCriterias.map((criteria: any) => {
            if (criteria.field) {
                fields.push(criteria.field);
                if (!addtionalFields.includes(criteria.field)) {
                    additionalFieldsArray.push(criteria.field);
                }
            }
            if(criteria.isDynamic && criteria.compareTo){
                fields.push(criteria.compareTo);
            }
        });
        this.props.updateVisibilityRuleObj(true, ruleObject, fields, this.state.isVisible, additionalFieldsArray);
        this.props.toggleModalVisibility();
    }
}